module.exports = __webpack_public_path__ + "static/media/icono_orquesta.12ee44e6.svg";